export class PersonAssessmentConsent {
    id: string; // Assessment ID
    consent: string; // Consent detail
}
